import { createSlice } from '@reduxjs/toolkit';

const initialState = { me: {} };

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		// TODO real user
	}
});

// eslint-disable-next-line no-empty-pattern
export const {} = userSlice.actions;
export default userSlice.reducer;
